module.exports = __webpack_public_path__ + "static/media/event-services-img25.c8660630.jpg";